const ENV = (typeof window !== 'undefined' && window.ENV) ? window.ENV : {
    CLOUDFLARE_ACCOUNT_ID: process.env.REACT_APP_CLOUDFLARE_ACCOUNT_ID,
    CLOUDFLARE_STREAM_UPLOAD_PROXY_URL: process.env.REACT_APP_CLOUDFLARE_STREAM_UPLOAD_PROXY_URL,
};

const CLOUDFLARE_ACCOUNT_ID = ENV.CLOUDFLARE_ACCOUNT_ID || '';
const CLOUDFLARE_STREAM_UPLOAD_PROXY_URL = (ENV.CLOUDFLARE_STREAM_UPLOAD_PROXY_URL || '').trim();

export {
    CLOUDFLARE_ACCOUNT_ID,
    CLOUDFLARE_STREAM_UPLOAD_PROXY_URL,
};
